module.exports = __webpack_public_path__ + "media/images/icons/material/timer-5272744ad867b68d74fe8beb370dcf41.svg";